interface ScriptWrapperParams {
  loadScreenMinWidth: string;
  loadScreenMaxWidth: string;
  showScreenMinWidth: string;
  showScreenMaxWidth: string;
  content: string;
  id: string;
}

// Adblocker Check
window.adbEnable = false;

// Script wrapper
function scriptWrapper(params: ScriptWrapperParams, write: boolean) {
	let html = '';
	let loadScreenMinWidth = parseInt(params.loadScreenMinWidth);
	let loadScreenMaxWidth = parseInt(params.loadScreenMaxWidth);
	let showScreenMinWidth = parseInt(params.showScreenMinWidth);
	let showScreenMaxWidth = parseInt(params.showScreenMaxWidth);
	let content = window.atob(params.content);
	let ts:number = Math.round((new Date()).getTime() / 1000);
	let assetId = 'th_asset_'+params.id;
	content = content.replace(/\[timestamp\]|%timestamp%|\{timestamp\}/ig, ts.toString());

	if(showScreenMinWidth > 0 || showScreenMaxWidth > 0) {
		let style = '';
		style += '<style type="text/css">#'+assetId+' { display: none; } @media only screen and ';
		if(showScreenMinWidth > 0) {
			style += '(min-width: ' + showScreenMinWidth + 'px) ';
		}
		if(showScreenMaxWidth > 0) {
			style += '(max-width: ' + showScreenMaxWidth  +'px) ';
		}
		style += '{ #'+assetId+' { display: block; } }</style>';
		content = '<div id="'+assetId+'" class="th-asset-content-wrapper" data-media-min-width="' + showScreenMinWidth+'" data-media-max-width="' + showScreenMaxWidth + '">'+content+'</div>';
		content = style+content;
	}

	let loadScript = true;
	let windowWidth = window.screen.width;
	if(loadScreenMinWidth > 0 && windowWidth < loadScreenMinWidth) {
		loadScript = false;
	}
	if(loadScreenMaxWidth > 0 && windowWidth > loadScreenMaxWidth) {
		loadScript = false;
	}
	if(loadScript) {
		html += content;
	}
	if(write) {
		document.write(html);
	}
	return html;
}

// Decrypt helper function
function decryptCharcode(n: number, start: number, end: number, offset: number) {
	n = n + offset;
	if (offset > 0 && n > end) {
		n = start + (n - end - 1);
	} else if (offset < 0 && n < start) {
		n = end - (start - n - 1);
	}
	return String.fromCharCode(n);
}

// Decrypt string
function decryptString(enc: string, offset: number) {
	let dec = "";
	let len = enc.length;
	for(let i=0; i < len; i++) {
		let n = enc.charCodeAt(i);
		if (n >= 0x2B && n <= 0x3A) {
			dec += decryptCharcode(n,0x2B,0x3A,offset);	/* 0-9 . , - + / : */
		} else if (n >= 0x40 && n <= 0x5A) {
			dec += decryptCharcode(n,0x40,0x5A,offset);	/* A-Z @ */
		} else if (n >= 0x61 && n <= 0x7A) {
			dec += decryptCharcode(n,0x61,0x7A,offset);	/* a-z */
		} else {
			dec += enc.charAt(i);
		}
	}
	return dec;
}

// Decrypt spam-protected emails
function linkTo_UnCryptMailto(s: string) {
	location.href = decryptString(s, -1);
}

// Show login
function showLogin(message: string, redirectUrl: string) {
	window.addEventListener('load', () => {
		window.ThiemeMaintemplate.showLogin(message, redirectUrl);
	}, { once: true });
}
